import { Injectable } from '@angular/core';
import { AuthService } from "src/app/modules/auth/_services/auth.service";
import { SplashScreenService } from 'src/app/_metronic/partials/layout/splash-screen/splash-screen.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SessionUserService {
  private verificando = false;

  constructor(
    private authService: AuthService,
    private splashScreenService: SplashScreenService,
    private tokenService: TokenStorageService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  verificarSesionUsuario(): void {
    if (this.verificando) {
      return;
    }
    const userSession = this.localStorageService.getUserSession();

    if (!userSession) {
      return;
    }

    const { cMaestra, id: sesionId, usuarioId } = userSession;

    if (cMaestra === true || !usuarioId || !sesionId) {
      return;
    }

    this.verificando = true;

    this.authService.verificarSesion(usuarioId, sesionId).subscribe({
      next: () => {
        this.verificando = false;
      },
      error: () => {
        this.verificando = false;
        this.splashScreenService.hide();
        this.tokenService.signOut();
        this.localStorageService.signOut();
        Swal.fire({
          icon: 'warning',
          title: 'Sesión cerrada',
          text: 'Tu sesión ha sido cerrada. Por favor, inicia sesión nuevamente.',
        }).then(() => {
          this.router.navigate(['/auth/login']);
        });
      }
    });
  }
}